/* global __APP_VERSION__ */

export const APP_VERSION =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : process.env.REACT_APP_VERSION || "0.0.0";
